import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import clamShellManager from "../../manager/clamShellManager";
import NormalGameManager from "../../manager/NormalGameManager";
import { clamShellEndInterface, clamShellEventInterface, clamShellStartInterface } from "./clamShellConst";
import clamShellGameObj from "./clamShellGameObj";

const {ccclass, property} = cc._decorator;

@ccclass
export default class clamShellGameClean extends cc.Component {

    cleanNode:cc.Node = null;

    @property({type:cc.Node,displayName:"普通的按钮layout"})
    normalBtnLayout:cc.Node = null;
    @property({type:cc.Node,displayName:"事件的按钮layout"})
    eventBtnLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"事件的出售按钮"})
    eventSellBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"top节点"})
    topNode:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    explainLb:cc.Label = null;

    @property({type:cc.Label,displayName:"名字文本"})
    nameLb:cc.Label = null;

    @property({type:cc.Label,displayName:"品级文本"})
    levelLb:cc.Label = null;

    @property({type:cc.Node,displayName:"光效节点"})
    lightNode:cc.Node = null;

    startData:clamShellStartInterface = null;
    endData:clamShellEndInterface = null;

    clamShellManager:clamShellManager = null;

    @property({type:cc.Node,displayName:"pushBack按钮"})
    pushBackBtn:cc.Node = null;

    onLoad(){
        this.clamShellManager = NormalGameManager._instance.clamShellManager;
    }

    start(){
        this.updatePage();
        let tween = cc.tween(this.lightNode).by(3,{angle:360}).call(()=>{
            this.lightNode.angle = 0;
        })
        cc.tween(this.lightNode).repeatForever(tween).start();
    }

    bindNode(node:cc.Node){
        this.cleanNode = node;
        this.cleanNode.setParent(this.topNode);
        this.cleanNode.setPosition(cc.v2(0,0));
    }

    updatePage(){
        if(this.cleanNode && this.cleanNode.isValid){
            let os = this.cleanNode.getComponent(clamShellGameObj);
            this.startData = os.startData;
            let endData = this.endData = os.endData;
            this.endData.price = Math.floor( NormalGameManager._instance.getPriceRate() * this.endData.price );
            let event:clamShellEventInterface = os.event;
            this.event = event;
            if(event){
                //触发事件
                this.setExplain(event.event_description);
                this.updateEventBtns();
            }else{
                // 没有事件 按照正常流程结算
                this.setExplain(endData.describe);
                this.updateNormalBtns();
                this.nameLb.string = endData.woodname;
                this.levelLb.string = endData.level;
            }
        }
    }

    event:clamShellEventInterface = null;

    //更新事件按钮
    updateEventBtns(){
        this.eventBtnLayout.active = true;

        let oneOption = this.event.event_option1;
        let twoOption = this.event.event_option2;

        let strs = [oneOption,twoOption];

        this.eventBtnLayout.children.forEach((n:cc.Node,index:number)=>{
            let str = strs[index];
            let lb:cc.Label = n.getChildByName("layout").getChildByName("lb").getComponent(cc.Label);
            if(str != ""){
                n.active = true;
                lb.string = str;
            }else{
                n.active = false;
            }
            let video:cc.Node = n.getChildByName("layout").getChildByName("video");
            if(this.event.event_category!=3 && index == 0){
                video.active = false;
            }else if(this.event.event_category == 3 && index == 0){
                video.active = false;
                this.optionEventHasVideo[0] = false;
            }
        });
    }

    optionEventHasVideo:boolean[] = [false,false];

    //更新普通按钮
    updateNormalBtns(){
        this.normalBtnLayout.active = true;
        let backpackId:number = null;
        if(this.event){
            backpackId = this.event.backpackId;
        }else{
            backpackId = this.endData.backpackId;
        }
        if(backpackId!=null){
            O1HD.getManagers().soundMgr.playSound("openTreasure").then();
            this.pushBackBtn.active = true;
        }else{
            this.pushBackBtn.active = false;
        }
        let btn:cc.Node = this.normalBtnLayout.children[1];
        let label = btn.getChildByName("layout").getChildByName("lb_money").getComponent(cc.Label);
        label.string = data_control.getNumberFormat(this.endData.price);
    }

    onBtnSell(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let targetNode:cc.Node = e.target;
        let coin = this.endData.price;
        O1HD.getServices().userSrv.setCoins(coin,true,targetNode);
        this.closeThis();
    }

    onBtnBack(){
        this.onPushBackPack();
        this.closeThis();
    }

    onPushBackPack(){
        let backpackId:number = null;
        if(this.event){
            backpackId = this.event.backpackId;
        }else{
            backpackId = this.endData.backpackId;
        }
        if(backpackId!=null){
            let obj = backPackEventMap()[backpackId];
            if(obj){
                NormalGameManager._instance.onPushGoods(backpackId,1);
                O1HD.getModules().uiControlModule.showMessageBox(`物品：${obj.name}已放入背包`);
            }
        }
    }

    onBtnPushBackPack(){
        this.onPushBackPack();
        this.closeThis();
    }

    onBtnEventSell(e:cc.Event.EventTouch){
        let coin = this.event.result_money;
        let targetNode:cc.Node = e?.target || this.node;
        if(coin!=0){
            O1HD.getServices().userSrv.setCoins(coin,true,targetNode);
        }
        this.closeThis();
    }

    updateEventSellBtn(){
        this.eventSellBtn.active = true;
        let label = this.eventSellBtn.getChildByName("layout").getChildByName("lb_money").getComponent(cc.Label);
        label.string = data_control.getNumberFormat(this.event.result_money);
    }

    onBtnOption(e:cc.Event.EventTouch,custom:string){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let isHaveVideo:boolean = this.optionEventHasVideo[Number(custom)];
        if(isHaveVideo){
            utilsModel.loadAndShowVideoAdTrans(()=>{
                // if(custom == "0"){

                //     this.startEndAni();
                // }else{
                    this.closeThis();
                // }
            },()=>{

            },null,"赌木看广告");
        }else{
            // if(custom == "0"){
                // let coin = this.event.result_money;
                // if(coin!=0){
                //     O1HD.getServices().userSrv.setCoins(coin,true,targetNode);
                // }
            //     this.startEndAni();
            // }else{
                this.closeThis();
            // }
        }
    }

    async setExplain(str:string){
        this.explainLb.string = "";
        return new Promise<void>(async resolve=>{
            for(let i = 0;i<str.length;i++){
                this.explainLb.string += str[i];
                await new Promise<void>(resolve=>{
                    this.scheduleOnce(resolve,0.02);
                });
            }
            resolve();
        });
    }

    async startEndAni(){
        this.updateEventSellBtn();
        this.normalBtnLayout.active = false;
        this.eventBtnLayout.active = false;
        await this.setExplain(this.event.result);
    }

    closeThis(){
        this.normalBtnLayout.active = false;
        this.eventBtnLayout.active = false;
        this.cleanNode?.destroy();
        this.cleanNode?.removeFromParent();
        this.node.destroy();
        this.node.removeFromParent();
    }
}
